import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { liquidacionesApi } from '@/data/api/liquidacionesApi';
const KEY = 'liquidaciones';
export function useLiquidaciones(filtros) {
    return useQuery({
        queryKey: [KEY, filtros],
        queryFn: () => liquidacionesApi.listar(filtros),
        placeholderData: (previous) => previous,
    });
}
export function useLiquidacion(id) {
    return useQuery({
        queryKey: [KEY, 'detalle', id],
        queryFn: () => liquidacionesApi.ver(id),
        enabled: Boolean(id),
    });
}
export function useItemsLiquidacion(id) {
    return useQuery({
        queryKey: [KEY, id, 'items'],
        queryFn: () => liquidacionesApi.items(id),
        enabled: Boolean(id),
    });
}
export function useGenerarLiquidacion() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => liquidacionesApi.generar(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useAjusteManual(liquidacionId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => liquidacionesApi.agregarAjuste(liquidacionId, v),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [KEY, liquidacionId, 'items'] });
            qc.invalidateQueries({ queryKey: [KEY, 'detalle', liquidacionId] });
            qc.invalidateQueries({ queryKey: [KEY] });
        },
    });
}
export function useAprobarLiquidacion() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => liquidacionesApi.aprobar(id),
        onSuccess: (l) => {
            qc.invalidateQueries({ queryKey: [KEY] });
            qc.setQueryData([KEY, 'detalle', l.id], l);
        },
    });
}
export function useMarcarPagadaLiquidacion() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, fechaPago }) => liquidacionesApi.marcarPagada(id, fechaPago),
        onSuccess: (l) => {
            qc.invalidateQueries({ queryKey: [KEY] });
            qc.setQueryData([KEY, 'detalle', l.id], l);
        },
    });
}
